import {Component} from 'react'
import {Redirect, Link} from 'react-router-dom'
import Cookies from 'js-cookie'
import {FaFire} from 'react-icons/fa'

import AppContext from '../../context/AppContext'

import Loader from '../Loader'
import FailureView from '../FailureView'
import Header from '../Header'
import SideBar from '../SideBar'

import {
  GamingContainer,
  GamingHeader,
  GamingIconContainer,
  GamingIcon,
  GamingPara,
  GamingVideos,
  GamingVideoCardContainer,
  GamingImgContainer,
  GamingVideoCardThumnailImg,
  GamingVideoCardTitle,
  GamingVideoCardViewCount,
} from './styledComponents'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN PROGRESS',
}

class Gaming extends Component {
  state = {apiStatus: apiStatusConstants.initial, gamingVideosList: []}

  componentDidMount() {
    this.getGamingApiCall()
  }

  onClickGamingRetryBtn = () => {
    this.getGamingApiCall()
  }

  getGamingApiCall = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})
    const jwtToken = Cookies.get('jwt_token')
    const url = 'https://apis.ccbp.in/videos/gaming'
    const options = {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
      method: 'GET',
    }
    const response = await fetch(url, options)
    if (response.ok === true) {
      const data = await response.json()
      const formattedData = data.videos.map(each => ({
        id: each.id,
        title: each.title,
        thumbnailUrl: each.thumbnail_url,
        viewCount: each.view_count,
      }))
      this.setState({
        apiStatus: apiStatusConstants.success,
        gamingVideosList: formattedData,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  renderSuccessView = () => {
    const {gamingVideosList} = this.state

    return (
      <AppContext.Consumer>
        {value => {
          const {theme} = value
          return (
            <GamingContainer theme={theme}>
              <GamingHeader theme={theme}>
                <GamingIconContainer theme={theme}>
                  <GamingIcon fill="#ff0000" as={FaFire} />
                </GamingIconContainer>
                <GamingPara theme={theme}>Gaming</GamingPara>
              </GamingHeader>
              <GamingVideos theme={theme}>
                {gamingVideosList.map(videoItem => (
                  <GamingVideoCardContainer
                    as={Link}
                    to={`/videos/${videoItem.id}`}
                    theme={theme}
                    key={videoItem.id}
                  >
                    <GamingImgContainer>
                      <GamingVideoCardThumnailImg
                        src={videoItem.thumbnailUrl}
                        alt="video thumbnail"
                      />
                    </GamingImgContainer>
                    <GamingVideoCardTitle theme={theme}>
                      {videoItem.title}
                    </GamingVideoCardTitle>
                    <GamingVideoCardViewCount theme={theme}>
                      {videoItem.viewCount} Watching Worldwide
                    </GamingVideoCardViewCount>
                  </GamingVideoCardContainer>
                ))}
              </GamingVideos>
            </GamingContainer>
          )
        }}
      </AppContext.Consumer>
    )
  }

  render() {
    const {apiStatus} = this.state
    const jwtToken = Cookies.get('jwt_token')
    const {match} = this.props
    const {path} = match
    if (jwtToken === undefined) {
      return <Redirect to="/login" />
    }
    return (
      <div data-testid="gaming">
        <Header />
        <SideBar path={path} />
        {(() => {
          switch (apiStatus) {
            case apiStatusConstants.inProgress:
              return <Loader />
            case apiStatusConstants.failure:
              return (
                <FailureView
                  gamingRetryBtn={this.onClickGamingRetryBtn}
                  path={path}
                />
              )
            case apiStatusConstants.success:
              return this.renderSuccessView()
            default:
              return null
          }
        })()}
      </div>
    )
  }
}

export default Gaming
